import React from 'react';

export const GridRow = ({children}) => {
    return (<div className="row">
        {children}
</div>)
}